module.exports = __webpack_public_path__ + "media/images/image1-fb94775fc3a0e035956c667831ce825c.png";